import { fieldTime } from "utils/fieldFormat";
import { bandOf, bandText, finiteNumber, formatCm, isTargetPlan, reasonText, runStateInfo } from "utils/radarLab";

const when = (value) => (value ? `${fieldTime(value)} SGT` : "—");

// Every lab run, newest first: open one to see its steps, level and captures.
export default function LabHistory({ runs, count, error, loading, selectedId, onSelect }) {
  return (
    <section className="field-panel" aria-labelledby="lab-history-title">
      <div className="field-panel-head">
        <div>
          <h2 id="lab-history-title">Lab runs</h2>
          <p>
            {loading && !runs.length
              ? "Loading…"
              : `${count ?? runs.length} lab run${(count ?? runs.length) === 1 ? "" : "s"}; the newest 20 are listed.`}
          </p>
        </div>
      </div>
      <div className="field-panel-body">
        {error && (
          <div className="field-alert" role="alert">
            {error}
          </div>
        )}
        {!runs.length && !loading ? (
          <p className="field-caption" style={{ marginTop: 0 }}>
            No lab runs yet. Start with the tier 0 smoke test.
          </p>
        ) : (
          <div className="field-lab-scroll">
            <table className="field-table field-lab-history">
              <thead>
                <tr>
                  <th scope="col">Lab run</th>
                  <th scope="col">State</th>
                  <th scope="col">Started</th>
                  <th scope="col">Steps</th>
                  <th scope="col">Level start → end</th>
                  <th scope="col">Clean</th>
                </tr>
              </thead>
              <tbody>
                {runs.map((run) => {
                  const info = runStateInfo(run.state);
                  return (
                    <tr key={run.id} className={selectedId === run.id ? "is-selected" : ""}>
                      <td>
                        <button
                          type="button"
                          className="field-lab-link"
                          aria-pressed={selectedId === run.id}
                          onClick={() => onSelect(run.id)}
                        >
                          #{run.id} · {run.label || run.preset}
                        </button>
                        <small style={{ display: "block", color: "#7b919c" }}>
                          Tier {run.tier}
                          {(finiteNumber(run.parts) ?? 1) > 1 ? ` · part ${run.part ?? 1} of ${run.parts}` : ""}
                          {bandOf(run) ? ` · ${bandText(run.band)}` : ""}
                        </small>
                      </td>
                      <td>
                        <span className={`field-state ${info.tone}`}>{run.state_text || info.label}</span>
                        {run.reason && !run.active && (
                          <small style={{ display: "block", color: "#7b919c", marginTop: 4 }}>{reasonText(run)}</small>
                        )}
                      </td>
                      <td>{when(run.armed_at || run.created_at)}</td>
                      <td>
                        {run.steps_done ?? 0} of {run.steps_total ?? "?"}
                        {isTargetPlan(run) && finiteNumber(run.targets_settled) !== null && (
                          <small style={{ display: "block", color: "#7b919c" }}>
                            {run.targets_hit ?? 0} of {run.targets_settled} on target
                          </small>
                        )}
                      </td>
                      <td>
                        {formatCm(run.start_level_cm)} → {formatCm(run.end_level_cm)}
                      </td>
                      <td>{run.active ? "—" : run.clean ? "Yes" : "No"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}
